<input
  #dateTimeInput
  [formControl]="formControl"
  type="hidden"
  data-cy="FieldInput:DateTimeInput"
/>

@switch (columnType) {
  @case ('Date') {
    <blaze-cell-date
      #cellDateComponent
      [column]="column"
      [rowNum]="rowNum"
      [value]="value"
      [isDisabled]="isDisabled"
      (valueChanged)="emitValueChanged($event)"
    />
  }
  @case ('Time') {
    <blaze-cell-time
      #cellTimeComponent
      [column]="column"
      [rowNum]="rowNum"
      [value]="value"
      [isDisabled]="isDisabled"
      (valueChanged)="emitValueChanged($event)"
    />
  }
  @case ('DateTime') {
    <blaze-cell-date-time
      [column]="column"
      [rowNum]="rowNum"
      [value]="value"
      [isDisabled]="isDisabled"
      (valueChanged)="emitValueChanged($event)"
    />
  }
}

@if (value && !column.isComputed) {
  <button blazeIconButton class="clear-date" tabindex="-1" (click)="clearDateTimeValue()">
    <mat-icon svgIcon="close" />
  </button>
}
